import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms'
import { SelectItemModel } from 'src/app/models/select-item'
import { QuoteService } from 'src/app/service/quote.service'
import { GetQuoteResponseModel } from 'src/app/service/web-api-client'
import { DatePipe } from '@angular/common';

@Component({
  selector: 'quote-step1',
  templateUrl: 'quote-step1.component.html',
  styleUrls: ['quote-step1.component.css'],
  providers: [DatePipe]
})
export class QuoteStep1Component implements OnInit {
  @Input()
  vectorsrc16: string = '/assets/external/vectori3287-riek.svg'
  @Input()
  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  progressBarPath: string = '/assets/external/Progress-bar.svg'
  progressBarTransparentPath: string = '/assets/external/Progress-bar-transparent.svg'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  ballPink1src: string = '/assets/external/basketball-resize.png'
  ballPink1srcNew: string = '/assets/external/newbasketball-resize.png'
  ballBlueSmall: string = '/assets/external/ballbluesmall-resize.png'
  ballPink1alt: string = 'BallPink13179'
  towerGrey: string = '/assets/external/tower-resize.png'
  towerNew: string = '/assets/external/tower-new-resize.png'
  @Input()
  pillSilverRight3alt: string = 'PillSilverRight33104'
  @Input()
  vectorsrc4: string = '/assets/external/vector3387-1bkg.svg'
  @Input()
  pillSilverRight3src: string =
    '/assets/external/pillsilverright33104-9pj-200w.png'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/b0b89e8a-76db-4798-862d-50833a4e1825?org_if_sml=11330&force_format=original'
  @Input()
  vectoralt15: string = 'VectorI3179'
  @Input()
  vectoralt3: string = 'Vector3387'
  @Input()
  pillSilverRight8src: string =
    '/assets/external/pillsilverright83179-cic-200h.png'
  @Input()
  ellipse25src3: string = '/assets/external/ellipse253387-sdsc.svg'
  @Input()
  vectoralt14: string = 'VectorI3179'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/4eae9314-bd07-4175-bc33-f86a83de5b32?org_if_sml=1624&force_format=original'
  @Input()
  pillSilverRight7src: string =
    '/assets/external/pillsilverright73179-gbvf-200h.png'
  @Input()
  vectoralt8: string = 'VectorI3179'
  @Input()
  ellipse25alt2: string = 'Ellipse253387'
  @Input()
  ellipse25src4: string = '/assets/external/ellipse253387-537j.svg'
  @Input()
  pillSilverRight7alt: string = 'PillSilverRight73179'
  @Input()
  ellipse25alt: string = 'Ellipse253387'
  @Input()
  revealpasssrc: string = '/assets/external/revealpassi3179-y8ai.svg'
  @Input()
  ellipse25alt3: string = 'Ellipse253387'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/5f8bbe0c-e82b-43c0-ae1c-f2803ad1dd49?org_if_sml=1521&force_format=original'
  @Input()
  pillSilverRight6src: string =
    '/assets/external/pillsilverright63104-zwhm-200h.png'
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f55c31a7-13eb-45ef-abf9-176ed8cfc4f2?org_if_sml=1171&force_format=original'
  @Input()
  vectoralt5: string = 'VectorI3179'
  @Input()
  vectoralt2: string = 'Vector3387'
  @Input()
  pillSilverRight6alt: string = 'PillSilverRight63104'
  @Input()
  vectorsrc1: string = '/assets/external/vector3387-eel3.svg'
  @Input()
  vectoralt10: string = 'VectorI3179'
  @Input()
  vectoralt17: string = 'VectorI3179'
  @Input()
  ellipse25alt1: string = 'Ellipse253387'
  @Input()
  pillSilverRight8alt: string = 'PillSilverRight83179'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/3f41e9a7-5d10-4e82-ac68-ff7fba18974c?org_if_sml=1502&force_format=original'
  @Input()
  vectorsrc11: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/8fa9a24c-97a8-4ba2-b10f-8ef658f1abc1?org_if_sml=1743&force_format=original'
  @Input()
  vectorsrc15: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/32ff291b-e6d6-44dd-ac1e-c177518abcc7?org_if_sml=1490&force_format=original'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/7aa8a602-3d16-4e41-bdc6-6af78e212b72?org_if_sml=1633&force_format=original'
  @Input()
  vectorsrc2: string = '/assets/external/vector3387-vn8i.svg'
  @Input()
  vectorsrc14: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/a95e1427-69ce-49d0-ab1b-ec2838adcdaf?org_if_sml=1740&force_format=original'
  @Input()
  luggageSilver2alt: string = 'LuggageSilver23104'
  @Input()
  vectorsrc13: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/97e4d759-acd7-443b-b2ee-5ffe22fcc1c0?org_if_sml=1222&force_format=original'

  @Input()
  vectoralt9: string = 'VectorI3179'
  @Input()
  vectoralt7: string = 'VectorI3179'
  @Input()
  vectoralt1: string = 'Vector3387'
  @Input()
  vectoralt12: string = 'VectorI3179'
  @Input()
  ellipse25src: string = '/assets/external/ellipse253387-r1xl.svg'
  @Input()
  vectoralt4: string = 'Vector3387'
  @Input()
  vectorsrc12: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/b07d1f73-1b66-48a2-9799-d27ca0b007ce?org_if_sml=1743&force_format=original'
  @Input()
  ellipse25src1: string = '/assets/external/ellipse253387-bd88.svg'
  @Input()
  vectoralt6: string = 'VectorI3179'
  @Input()
  vectorsrc17: string = '/assets/external/vectori3179-jv29.svg'
  @Input()
  revealpassalt: string = 'RevealpassI3179'
  @Input()
  vectoralt: string = 'Vector3387'
  @Input()
  vectoralt16: string = 'VectorI3287'
  @Input()
  ellipse25alt4: string = 'Ellipse253387'
  @Input()
  vectoralt13: string = 'VectorI3179'
  @Input()
  vectoralt11: string = 'VectorI3179'
  @Input()
  ellipse25src2: string = '/assets/external/ellipse253387-ufp.svg'
  @Input()
  rootClassName: string = ''

  @Input() currentStep: number;
  @Input() screenWidth: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  minDate: Date = new Date();

  stepTwoForm: FormGroup;

  countries: SelectItemModel[];
  regionToFly: SelectItemModel[];

  get canContinue(): boolean {
    return (this.stepTwoForm.controls.rangeDates.value && this.stepTwoForm.controls.rangeDates.value.length == 2 && this.stepTwoForm.controls.rangeDates.value[1] > this.stepTwoForm.controls.rangeDates.value[0])
      && this.stepTwoForm.valid;
  }

  get duration(): number {
    if (!this.stepTwoForm.controls.rangeDates.value || this.stepTwoForm.controls.rangeDates.value.length != 2) {
      return 0;
    }

    const startDate: Date = this.stepTwoForm.controls.rangeDates.value[0];
    const endDate: Date = this.stepTwoForm.controls.rangeDates.value[1];

    if (startDate >= endDate) {
      return 0;
    }

    var diff = Math.abs(endDate.getTime() - startDate.getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    return diffDays + 1;
  }
  submitted = false;
  dateRangeErrorMessage: string | null = null;

agentCodeLoading: boolean = false;
agentCodeError: string | null = null;


  constructor(
    private quoteService: QuoteService,
    private datePipe: DatePipe,
    private fb: FormBuilder) {
    this.createForm()
  }

  createForm() {
    this.stepTwoForm = this.fb.group({
      rangeDates: [null, Validators.required],
      selectedTravelCountry: [null, Validators.required],
      selectedResidentCountry: [null, Validators.required],
      agentCode: [null]
    });
  }

  nextStep(): void {
    this.submitted = true;
    // Validate minimum 3-day duration
    this.dateRangeErrorMessage = null;
    const hasRange = this.stepTwoForm.controls.rangeDates.value && this.stepTwoForm.controls.rangeDates.value.length == 2;
    
    // Check if dates are the same or invalid
    if (hasRange) {
      const startDate = this.stepTwoForm.controls.rangeDates.value[0];
      const endDate = this.stepTwoForm.controls.rangeDates.value[1];
      
      // Check if end date is before or equal to start date
      if (endDate <= startDate) {
        this.dateRangeErrorMessage = 'La fecha de fin debe ser posterior a la fecha de inicio';
        const currentErrors = this.stepTwoForm.controls.rangeDates.errors || {};
        this.stepTwoForm.controls.rangeDates.setErrors({ ...currentErrors, invalidRange: true });
        return;
      }
      
      // Check minimum 3-day duration
      if (this.duration < 3) {
        this.dateRangeErrorMessage = 'Mínimo 3 días de viaje';
        const currentErrors = this.stepTwoForm.controls.rangeDates.errors || {};
        this.stepTwoForm.controls.rangeDates.setErrors({ ...currentErrors, minDuration: true });
        return;
      }
    }

    if (this.stepTwoForm.valid) {
      this.quoteService.quoteModel.agentCode = this.stepTwoForm.controls.agentCode.value
      if (this.stepTwoForm.controls.rangeDates.value) {
        this.quoteService.quoteModel.tripStartDate = this.datePipe.transform(this.stepTwoForm.controls.rangeDates.value[0], 'yyyy-MM-dd');
        this.quoteService.quoteModel.tripEndDate = this.datePipe.transform(this.stepTwoForm.controls.rangeDates.value[1], 'yyyy-MM-dd');
      }

      if (this.stepTwoForm.controls.selectedResidentCountry.value) {
        let countryId = this.stepTwoForm.controls.selectedResidentCountry.value;
        if (countryId) {
          this.quoteService.quoteModel.residenceCountryId = parseInt(countryId);
          if(this.quoteService.quoteModel.residenceCountry?.name){
            this.quoteService.quoteModel.residenceCountry.name = this.countries.find(x => x.id == countryId).text;
            this.quoteService.quoteModel.residenceCountry.id = parseInt(countryId);
          }
        }
      }

      if (this.stepTwoForm.controls.selectedTravelCountry.value) {
        let geographicalDestinationId = this.stepTwoForm.controls.selectedTravelCountry.value;
        if (geographicalDestinationId) {
          if(this.quoteService.quoteModel.destinationRegion?.name){
            this.quoteService.quoteModel.destinationRegion.name = this.regionToFly.find(x => x.id == geographicalDestinationId).text;
            this.quoteService.quoteModel.destinationRegion.id = parseInt(geographicalDestinationId);
          }
          this.quoteService.quoteModel.destinationRegionId = parseInt(geographicalDestinationId);
        }
      }
      this.quoteService.fromStepTwo = false
      this.onNextStep.emit(this.currentStep);
    }
  }

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
  }


  ngOnInit(): void {
    console.log('this.quoteService.fromStepTwo: ', this.quoteService.fromStepTwo);
    console.log('this.quoteService.quoteModel: ', this.quoteService.quoteModel);
    // if (!this.quoteService.fromStepTwo) {
    //   this.quoteService.quoteModel = new GetQuoteResponseModel()
    //   this.quoteService.fromStepTwo = false
    // }
    const self = this;
    this.quoteService.getCountries$().subscribe(allCountries => {

      self.countries = allCountries.map(value => {
        let item: SelectItemModel = {
          id: value.id,
          text: value.name,
          value: value
        };
        return item;
      })
    });

    this.quoteService.getRegions$().subscribe(allRegions => {

      self.regionToFly = allRegions.map(value => {
        let item: SelectItemModel = {
          id: value.id,
          text: value.name,
          value: value
        };
        return item;
      })
    });

    this.initializeData()
    // Clear errors when user fixes the date range
    const rangeControl = this.stepTwoForm.get('rangeDates');
    rangeControl?.valueChanges.subscribe(() => {
      const control = this.stepTwoForm.controls.rangeDates;
      // Reset message on any change
      this.dateRangeErrorMessage = null;
      
      if (control.value && control.value.length == 2) {
        const startDate = control.value[0];
        const endDate = control.value[1];
        const currentErrors = control.errors ? { ...control.errors } : null;
        let hasErrors = false;
        
        // Remove invalidRange error if dates are now valid
        if (endDate > startDate) {
          if (currentErrors && currentErrors.invalidRange) {
            delete currentErrors.invalidRange;
            hasErrors = true;
          }
          
          // If duration is now valid (>= 3), remove minDuration error
          if (this.duration >= 3) {
            if (currentErrors && currentErrors.minDuration) {
              delete currentErrors.minDuration;
              hasErrors = true;
            }
          }
        }
        
        // Update errors if any were removed
        if (hasErrors) {
          control.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
        }
      }
    });
  }

  initializeData(): void {
    console.log('this.quoteService.quoteModel: ', this.quoteService.quoteModel);
    if (this.quoteService?.quoteModel) {
      if(this.quoteService.quoteModel?.agentCode){
        this.stepTwoForm.controls.agentCode.setValue(this.quoteService.quoteModel.agentCode)
      }
      if (this.quoteService.quoteModel?.residenceCountryId || this.quoteService.quoteModel.residenceCountry?.id) {
        this.stepTwoForm.controls.selectedResidentCountry.setValue(this.quoteService.quoteModel.residenceCountryId || this.quoteService.quoteModel.residenceCountry.id)
      }
      if (this.quoteService.quoteModel?.destinationRegionId || this.quoteService.quoteModel.destinationRegion?.id) {
        this.stepTwoForm.controls.selectedTravelCountry.setValue(this.quoteService.quoteModel.destinationRegionId || this.quoteService.quoteModel.destinationRegion.id)
      }
      if (this.quoteService.quoteModel?.tripStartDate && this.quoteService.quoteModel?.tripEndDate) {
        this.stepTwoForm.controls.rangeDates.setValue([new Date(this.quoteService.quoteModel?.tripStartDate), new Date(this.quoteService.quoteModel?.tripEndDate)])
      }
      this.stepTwoForm.controls.agentCode.setValue(null)
    }
  }

  validateAgentCode(): void {
  const agentCode = this.stepTwoForm.controls.agentCode.value;

  if (!agentCode) {
    this.agentCodeError = null;
    return;
  }

  this.agentCodeLoading = true;
  this.agentCodeError = null;

  this.quoteService.validateAgentCode(agentCode).subscribe({
    next: (response) => {
      if (!response) {
        this.agentCodeError = 'Invalid agent code.';
      } else {
        this.agentCodeError = null;
      }
      this.agentCodeLoading = false;
    },
    error: (err) => {
      this.agentCodeError = 'An error occurred while validating the code.';
      this.agentCodeLoading = false;
    }
  });
}
}
